import { BaseDto } from './base.dto';
import { VATRateDto } from './vat-rate.dto';
import { SaleMediumDto } from './saleMedium.dto';

export class VATRateValueDto extends BaseDto {
  vatRateId: number;
  vatRate: VATRateDto;
  saleMediumId: number;
  saleMedium: SaleMediumDto;
  amount: number;
  effectiveFrom: Date;
}
